import { render, staticRenderFns } from "./TeachStudio.vue?vue&type=template&id=42088e6e&scoped=true"
import script from "./TeachStudio.vue?vue&type=script&lang=js"
export * from "./TeachStudio.vue?vue&type=script&lang=js"
import style0 from "./TeachStudio.vue?vue&type=style&index=0&id=42088e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42088e6e",
  null
  
)

export default component.exports